/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */

import AppDispatcher from '../dispatcher/AppDispatcher';
import Authentication from '../authentication/awsAuthentication';
import API from './awsApi';

class DealerAPIClass {
    constructor() {
    }

    allDealerJobs(dealerId) {
        Authentication.getSession()
        .then(Authentication.getAuthorisation)
        .then((token) => {
            var dataService = API.newClient();            
            console.log("[API-DEALER] dealer users :", dealerId);
            var params = {'dealerId' : dealerId, "Authorization": token};        
            dataService.defaults.headers.common['Authorization'] = token;            
            API.handleResponse(dataService.get('/api/v1/dealer/' + dealerId + '/jobs', params), "DEALER-JOBS-LOADED", "DEALER-JOBS-LOAD-ERROR");
        })
        .catch((e) => {
            AppDispatcher.handleViewAction({
                actionType  : "DEALER-JOBS-LOAD-ERROR",
                status      : "ERROR",
                error       : e
            });
        });
    }

    assignJobToDealer(jobId,dealerId) {
        console.log("[API-DEALER] ASSIGN JOB " + jobId + " TO DEALER " + dealerId) ;
    }

    removeJobFromDealer(jobId,dealerId) {
        console.log("[API-DEALER] REMOVE JOB " + jobId + " FROM DEALER " + dealerId) ;
    }

    assignUserToDealer(userId,dealerId) {
        console.log("[API-DEALER] ASSIGN USER " + userId + " TO DEALER " + dealerId) ;        
    }

    removeUserFromDealer(userId,dealerId) {
        console.log("[API-DEALER] REMOVE USER " + userId + " FROM DEALER " + dealerId) ;        
    }
}

const DealerAPI = new DealerAPIClass();
export default DealerAPI;



// WEBPACK FOOTER //
// ./src/app/api/awsDealerApi.js